export const styles = {
  accordionDynamicCells: {
    '&.MuiAccordionDetails-root': {
      pb: 1,
    },
  },
  accordionButton: {
    display: 'flex',
    mx: 'auto',
    mb: 1,
  },
};
